export default __webpack_public_path__ + "static/audio-cardio-6-e-9d8abc369b2366d4d38019b22c952e6c.webp";